import { parseOAuthAuthError } from 'utils/googleAuthUtils';

/** Parse a Microsoft (MSAL/backend) auth error into the shared OAuth error shape. */
export const parseMicrosoftAuthError = (err) =>
	parseOAuthAuthError(err, 'Microsoft authentication failed');
